@let itemTmpl = itemTemplate();
@let headerTmpl = headerTemplate();
@let emptyTmpl = emptyTemplate();
@let inputTmpl = inputTemplate();

<app-bottom-dialog
  [visible]="visible()"
  [focusOnShow]="focusOnShow()"
  (visibleChange)="onVisibleChange($event)"
  (placed)="onPlaced()"
  (shown)="onShown()"
>
  <div class="content">
    @if (heading()) {
      <div class="text-18 fw-600 color-gray-900 mb-16">{{ heading() }}</div>
    }
    <div class="list">
      <header #header>
        @if (inputTmpl) {
          <ng-container [ngTemplateOutlet]="inputTmpl"></ng-container>
        } @else {
          <p-iconfield class="w100">
            <input
              #searchInput
              pInputText
              type="text"
              class="h--40 w100"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              [attr.inputmode]="inputMode()"
              [attr.enterkeyhint]="freeText() ? 'done' : 'search'"
              [placeholder]="placeholder() || ('button.search' | translate)"
              [ngModel]="query()"
              (ngModelChange)="onQueryChange($event)"
              (keydown.enter)="onEnter($event)"
            />
            <p-inputicon>
              @if (query()) {
                <app-icon-close
                  class="clickable"
                  [width]="20"
                  [height]="20"
                  [color]="'var(--color-gray-500)'"
                  (click)="clearQuery(searchInput)"
                ></app-icon-close>
              } @else if (!freeText()) {
                <app-icon-search
                  [width]="20"
                  [height]="20"
                  [color]="'var(--color-gray-500)'"
                ></app-icon-search>
              }
            </p-inputicon>
          </p-iconfield>
        }
      </header>

      <div #scrollWrapper class="scroll-wrapper scrollbar-gray">
        @switch (status()) {
          @case ('loading') {
            <div
              class="loader-overlay flex justify-center align-items-center"
              role="status"
              [attr.aria-label]="'common.loading' | translate"
            >
              <div class="loader"></div>
            </div>
          }
          @case ('results') {
            @if (headerTmpl) {
              <ng-container [ngTemplateOutlet]="headerTmpl"></ng-container>
            }
            @for (option of suggestions(); track $index) {
              <div
                class="option-item p-10-16 flex align-items-center w100 gap-8"
                [class.selected]="$index === selectedIndex()"
                (click)="tapOption(option)"
              >
                @if (itemTmpl) {
                  <ng-container
                    [ngTemplateOutlet]="itemTmpl"
                    [ngTemplateOutletContext]="{ $implicit: option }"
                  ></ng-container>
                } @else {
                  <div class="text-14">{{ getOptionLabel(option) }}</div>
                }
              </div>
            }
          }
          @case ('empty') {
            @if (headerTmpl) {
              <ng-container [ngTemplateOutlet]="headerTmpl"></ng-container>
            }
            @if (emptyTmpl) {
              <div class="empty-slot">
                <ng-container [ngTemplateOutlet]="emptyTmpl"></ng-container>
              </div>
            } @else {
              <div class="option-item p-10-16 text-14">{{ 'common.no-results' | translate }}</div>
            }
          }
        }
      </div>
    </div>
    <footer class="flex gap-12 mt-16">
      <p-button class="h--40 text-14 fw-600 w50" [severity]="'secondary'" (click)="cancelValue()">
        {{ 'button.cancel' | translate }}
      </p-button>
      <p-button class="h--40 text-14 fw-600 w50" [disabled]="!canApply()" (click)="applyValue()">
        {{ applyLabel() || ('button.apply' | translate) }}
      </p-button>
    </footer>
  </div>
</app-bottom-dialog>
